import { TextField } from "@material-ui/core";
import WkEditor from "components/atoms/inputs/WkEditor";
import SelectStatus from "components/atoms/inputs/SelectStatus";
import UploadImage from "components/organisims/UploadImage";
import UploadStorage from "components/organisims/UploadStorage";
import TextClipboard from "components/atoms/TextClipboard";
import Checkbox from "components/atoms/inputs/SingleCheckbox";
import InputAdornment from "@material-ui/core/InputAdornment";
import React from "react";
import AlbumForm from "components/organisims/AlbumForm";
import { Status } from "API";
import SelectBrand from "components/molecures/CmsSelectBrand";
import SelectBoatType from "components/molecures/CmsSelectType";

// カレンダー
const TextFieldDatetime = (
  <TextField
    type="datetime-local"
    // inputRef={register}
    // className={classes.textField}
    InputLabelProps={{
      shrink: true,
    }}
  />
);
// 時間
const TextFieldTime = (
  <TextField
    type="time"
    // inputRef={register}
    // className={classes.textField}
    InputLabelProps={{
      shrink: true,
    }}
  />
);

export const show = [
  { name: "name", as: TextField, rules: { required: true } },
  { name: "owner", as: TextField, rules: { required: true } },
];

export const teaser = [
  { name: "showID", as: TextField, InputProps: { readOnly: true } },
  {
    name: "title",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "backgroundImage",
    input_name: "teaserBackgroundImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "countDown",
    as: Checkbox,
    onChange: (contents: any) => {
      return contents[1];
    },
  },
  {
    name: "discription",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "section",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  { name: "status", as: SelectStatus, defaultValue: Object.keys(Status)[1] },
];

export const showMain = [
  { name: "showID", as: TextField, InputProps: { readOnly: true } },
  {
    name: "title",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "backgroundImage",
    input_name: "showMainBackgroundImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "search",
    as: Checkbox,
    onChange: (contents: any) => {
      return contents[1];
    },
  },
  {
    name: "mapDiscription",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "logoDiscription",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "discription",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "section",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  { name: "status", as: SelectStatus, defaultValue: Object.keys(Status)[1] },
];

export const page = [
  {
    name: "title",
    as: <TextField fullWidth />,
  },
  { name: "root", as: TextField },
  { name: "discription", as: <TextField fullWidth multiline /> },
  { name: "slug", as: TextField, rules: { required: true } },
  {
    name: "backgroundImage",
    input_name: "pageBackgroundImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "contents",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  { name: "status", as: SelectStatus, defaultValue: Object.keys(Status)[1] },
];

export const topPage = [
  {
    name: "title",
    as: <TextField fullWidth />,
  },
  { name: "discription", as: <TextField fullWidth multiline /> },
  {
    name: "backgroundImage",
    input_name: "topPageBackgroundImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "contents",
    defaultValue: "",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
];

export const showSetting = [
  { name: "showID", as: TextField, InputProps: { readOnly: true } },
  { name: "name", as: TextField, rules: { required: true } },
  { name: "slug", as: TextField, rules: { required: true } },
  { name: "startDateTime", as: TextFieldDatetime, rules: { required: true } },
  { name: "endDateTime", as: TextFieldDatetime, rules: { required: true } },
  { name: "title", as: TextField },
  { name: "description", as: <TextField fullWidth multiline /> },
  {
    name: "ogpImage",
    input_name: "showSettingOgpImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  { name: "status", as: SelectStatus, defaultValue: Object.keys(Status)[1] },
];

export const showBooth = [
  { name: "showID", as: TextField, InputProps: { readOnly: true } },
  { name: "name", as: TextField },
  {
    name: "title",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "backgroundImage",
    input_name: "showBoothBackgroundImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "brandLogos",
    input_name: "showBoothBrandLogosId",
    as: AlbumForm,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "section",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  { name: "priority", as: <TextField type="number" /> },
  { name: "status", as: SelectStatus, defaultValue: Object.keys(Status)[1] },
];

export const showBoothItem = [
  { name: "showID", as: TextField, InputProps: { readOnly: true } },
  { name: "name", as: TextField },
  { name: "readingName", as: TextField },
  {
    name: "title",
    defaultValue: "タイトルを入力してください。",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "mainImage",
    input_name: "showBoothItemMainImageId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "logo",
    input_name: "showBoothItemLogoId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  {
    name: "description",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "photoGallery",
    input_name: "showBoothItemPhotoGalleryId",
    as: AlbumForm,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  { name: "productUrl", as: TextField, fullWidth: true },
  { name: "movie", as: TextField, fullWidth: true },
  { name: "view360", as: TextField, fullWidth: true },
  {
    name: "section",
    as: WkEditor,
    onChange: (contents: string) => {
      return contents[0];
    },
  },
  {
    name: "keyword",
    as: (
      <TextField helperText="複数ある場合は半角スペース区切りで追加してください。" />
    ),
  },
  {
    name: "brand",
    as: SelectBrand,
  },
  {
    name: "boatType",
    as: SelectBoatType,
  },
  {
    name: "price",
    as: (
      <TextField
        type="number"
        InputProps={{
          endAdornment: <InputAdornment position="start">万円</InputAdornment>,
        }}
      />
    ),
  },
  // {
  //   name: "width",
  //   as: (
  //     <TextField
  //       type="number"
  //       helperText="少数点入力可能"
  //       InputProps={{
  //         endAdornment: <InputAdornment position="start">m</InputAdornment>,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   name: "waterline",
  //   as: (
  //     <TextField
  //       type="number"
  //       InputProps={{
  //         endAdornment: <InputAdornment position="start">m</InputAdornment>,
  //       }}
  //     />
  //   ),
  // },
  {
    name: "height",
    as: (
      <TextField
        type="number"
        helperText="少数点入力可能"
        InputProps={{
          endAdornment: <InputAdornment position="start">ft</InputAdornment>,
        }}
      />
    ),
  },
  // {
  //   name: "capacity",
  //   as: (
  //     <TextField
  //       type="number"
  //       InputProps={{
  //         endAdornment: <InputAdornment position="start">名</InputAdornment>,
  //       }}
  //     />
  //   ),
  // },
  {
    name: "badge",
    as: TextField,
  },
  {
    name: "mapIcon",
    input_name: "showBoothItemMapIconId",
    as: UploadImage,
    onChange: (contents: any) => {
      return contents[0];
    },
  },
  { name: "mapPriority", as: <TextField type="number" /> },
  { name: "priority", as: <TextField type="number" /> },
  { name: "status", as: SelectStatus, defaultValue: Object.keys(Status)[1] },
];

export const boothUserInfo = [
  { name: "contactTel", as: TextField },
  { name: "contactTelInfo", as: TextField },
  { name: "contactEmail", as: TextField },
  { name: "contactAddress", as: <TextField multiline rowsMax={4} /> },
  { name: "chatUrl", as: TextField },
  { name: "web", as: TextField },
  { name: "facebook", as: TextField },
  {
    name: "chatStatus",
    as: SelectStatus,
    defaultValue: Object.keys(Status)[1],
  },
];

export const boothBoatType = [
  {
    name: "name",
    as: TextField,
  },
  { name: "priority", as: <TextField type="number" /> },
];
export const boothBoatBrand = [
  {
    name: "name",
    as: TextField,
  },
  { name: "priority", as: <TextField type="number" /> },
];

export const showAudience = [{ name: "name", as: TextField }];

export const album = [{ name: "name", as: TextField }];

export const image = [
  { name: "alternate", as: TextField, rules: { required: true } },
  { name: "url", as: TextClipboard },
  {
    name: "storage",
    as: UploadStorage,
    input_name: ["storage", "url"],
    onChange: (contents: any) => {
      return contents[0];
    },
  },
];
